import React, { Dispatch, useEffect } from 'react'
import { AnyAction } from '@reduxjs/toolkit'
import { Button } from 'primereact/button'
import * as Sentry from '@sentry/react'
import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'
import { OverlayPanel } from 'primereact/overlaypanel'
import { useRef, useState } from 'react'
// import HintButton from '../../../assets/images/bulb.svg'
// import HintButton from '../../../assets/images/hint-btn.svg'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchQuestionSolvedPuzzleByLocaleRequest,
  fetchUsedHintsRequest,
  fetchWellDoneBackgroundRequest,
  postPuzzleAnswerRequest,
  postPuzzleHintRequest,
  postSkipPuzzleRequest,
  postSkipPuzzleSuccess,
  setPuzzleAnswer,
} from '../../../redux/actions/gameActions'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchQuestionByLocaleRequest } from './../../../redux/actions/gameActions'
import { getGameSelector } from './../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import Loading from './../../../components/Loading'
import * as DOMPurify from 'dompurify'
import LoadingSpinner from '../../../components/LoadingSpinner'
import Confetti from '../components/Confetti'
import inputChangeSound from '../../../assets/audio/input-sound.wav'
import answerCorrect from '../../../assets/audio/answer-correct.wav'
import answerWrong from '../../../assets/audio/answer-wrong.mp3'
// import wellDone from '../../../assets/audio/welldone.wav'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import socket, { ENDPOINT } from '../../../utils/socketIO'
import jwt_decode from 'jwt-decode'
import { classNames } from 'primereact/utils'
import { gsap } from 'gsap'
import { Knob } from 'primereact/knob'
import { Trans, useTranslation } from 'react-i18next'
import {
  AlignBottom,
  ArrowCircleRight2,
  ArrowRight,
  BackSquare,
  Danger,
  GridEraser,
  Like1,
  Map,
  Send2,
} from 'iconsax-react'
import useSound from 'use-sound'
import client from '../../../client'
import { Dialog } from 'primereact/dialog'
import { RadioButton } from 'primereact/radiobutton'
import ScrollableWheel from './ScrollableWheel'
import {
  generateCssClassYes,
  generateCssClassNo,
} from '../../../utils/confirmDialogClasses'
import axios from 'axios'
import { decodeIframeString } from '../../../utils/decodeIframeString'

const GamePuzzle = () => {
  const { questionId, localeId } = useParams()
  const {
    data: {
      questionByLocale,
      puzzleAnswer,
      usedHints,
      selectedLanguage,
      skipPuzzle,
      wellDoneBackground,
      volumeGlobal,
      teamName,
      branding,
    },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)

  // const [activeAnswerType, setActiveAnswerType] = useState(3)
  // const [hintAgree, setHintAgree] = useState(false)
  const [textAnswer, setTextAnswer] = useState('')
  // const [padLockValue, setPadLockValue] = useState(111)
  // const [visible, setVisible] = useState<boolean>(false)
  const [choices, setChoices] = useState([
    { key: '1', checked: false, value: 'Choice 1' },
  ])
  const [timer, setTimer] = useState<number | null>(null)
  const [gameTimerReminderDialog, setGameTimerReminderDialog] =
    useState<any>(null)
  const [gameTimerDialog, setGameTimerDialog] = useState('')
  // const [timer, setTimer] = useState<number | string>(0)
  // const [initialLanguage, setInitialLanguage] = useState(null)
  const [displayWellDone, setDisplayWellDone] = useState(false)
  // const [value2, setValue2] = useState(100)
  const puzzleTimeValue = useRef<number>(0)
  const [showHintDialog, setShowHintDialog] = useState(false)
  const [showWrongReminder, setShowWrongReminder] = useState(false)
  const [wakeLock, setWakeLock] = useState<any>(null)
  const padlockAnswer = useRef<any>([])
  const lockWrapper = useRef(null)
  const activeAnswerType = useRef<any>(1)
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const navigate = useNavigate()
  // Sound effects
  const [inputSound] = useSound(inputChangeSound, {
    volume: volumeGlobal,
  })

  const [correctAnswerSound] = useSound(answerCorrect, {
    volume: volumeGlobal,
  })
  const [wrongAnswerSound] = useSound(answerWrong, {
    volume: volumeGlobal,
  })
  // const [finishedPuzzleSound] = useSound(wellDone, {
  //   volume: volumeGlobal,
  // })
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const { t } = useTranslation()

  const token = localStorage.getItem('tokenCityHunt') ?? ''

  const { UserIdGame, TeamId }: any = jwt_decode(token)

  const isUserUsingSeconds = UserIdGame == 25

  useEffect(() => {
    socket.emit('join-room', TeamId, (response: any) => {
      if (response.status === 'OK') {
        socket
          .off('timer-countdown')
          .on('timer-countdown', (time: number, puzzleTime: number) => {
            if (!puzzleTimeValue.current) {
              puzzleTimeValue.current = puzzleTime
            }
            if (time > 0) {
              setTimer(time)
            } else {
              setTimer(0)
            }
          })
      } else {
        console.error('Failed to join room')
      }
    })
    socket.emit('join-game-timer-room', TeamId)
    socket.emit('check-if-game-time-expired', TeamId)

    socket
      .off(`rooms/solvedPuzzle/${TeamId}`)
      .on(`rooms/solvedPuzzle/${TeamId}`, (data: any) => {
        //show well done
        if (!puzzleAnswer && data.typeOfAction === 'correctAnswer') {
          if (data.localeId && Number(data.localeId) !== Number(localeId)) {
            data.questionId = questionId
            data.localeId = localeId
            dispatch(fetchQuestionSolvedPuzzleByLocaleRequest(data))
            data.wellDoneHtml = t('Loading')
          }
          dispatch(setPuzzleAnswer(data))
        }
        if (data.typeOfAction === 'puzzleSkipped') {
          // setSkippedPuzzle(true)
          if (!skipPuzzle) {
            data.questionId = questionId
            data.localeId = localeId
            dispatch(fetchQuestionSolvedPuzzleByLocaleRequest(data))
            data.skipHtml = t('Loading')
            dispatch(
              postSkipPuzzleSuccess({
                data,
              }),
            )
          }
        }
      })

    socket
      .off('game-timer-countdown')
      .on('game-timer-countdown', async (data: any) => {
        if (data.currentTime > 0) {
          if (data.currentTime === data.timerTime - data.timerEndReminderTime) {
            setGameTimerReminderDialog(data)
          }
        } else {
          let description = data.timerDescription

          if (description.includes('[teamName]')) {
            await client
              .get(`Team/GetTeamName`, {
                headers: {
                  Authorization: `Bearer ${JSON.parse(token)}`,
                },
              })
              .then((responseTeamName) => {
                let teamName = responseTeamName.data.data
                description = description.replace('[teamName]', teamName)
                setGameTimerDialog(description)
              })
          } else {
            setGameTimerDialog(description)
          }
        }
      })

    socket.on(`rooms/checkTimeExpired/${TeamId}`, (isTimeExpired: boolean) => {
      if (isTimeExpired) {
        setTimer(0)
      }
    })

    socket.on(
      `rooms/checkGameTimerTimeExpired/${TeamId}`,
      (isTimeExpired: boolean) => {
        if (isTimeExpired) {
          setGameTimerDialog(t('Loading'))
          const getTimerData = async () => {
            await client
              .get('Team/EndTimer', {
                headers: {
                  Authorization: `Bearer ${JSON.parse(token)}`,
                },
              })
              .then(async (response) => {
                if (response.data.data.timerTime) {
                  let description = response.data.data.timerDescription

                  if (description.includes('[teamName]')) {
                    if (!teamName) {
                      await client
                        .get(`Team/GetTeamName`, {
                          headers: {
                            Authorization: `Bearer ${JSON.parse(token)}`,
                          },
                        })
                        .then((responseTeamName) => {
                          let teamName = responseTeamName.data.data
                          description = description.replace(
                            '[teamName]',
                            teamName,
                          )
                          setGameTimerDialog(description)
                        })
                    } else {
                      description = description.replace('[teamName]', teamName)
                      setGameTimerDialog(description)
                    }
                  } else {
                    setGameTimerDialog(description)
                  }
                }
              })
          }
          getTimerData()
        }
      },
    )

    const tryWakeLock = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let wakeLock = await navigator.wakeLock.request('screen')
        setWakeLock(wakeLock)
      } catch (err) {
        Sentry.captureException(err)
        // The Wake Lock request has failed - usually system related, such as battery.
        console.log(err)
      }
    }

    tryWakeLock()

    document.addEventListener('visibilitychange', async () => {
      if (wakeLock !== null && document.visibilityState === 'visible') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let newWakeLock = await navigator.wakeLock.request('screen')
        setWakeLock(newWakeLock)
      }
    })

    document.getElementById('btn')?.click()

    return () => {
      document.removeEventListener('visibilitychange', () =>
        console.log('wake lock removed'),
      )
      if (wakeLock) {
        wakeLock.release()
      }
    }

    // PADLOCK
    // renderItems()
  }, [])

  useEffect(() => {
    if (skipPuzzle) {
      // setSkippedPuzzle(true)
      navigate(`/game/${questionId}/${localeId}/skip`)
    }
  }, [skipPuzzle])

  const displayWellDoneScreen = () => {
    if (activeAnswerType.current === 3) {
      setTimeout(() => {
        // setDisplayWellDone(true)
        navigate(`/game/${questionId}/${localeId}/welldone`)
      }, 4000)
    } else {
      // setDisplayWellDone(true)
      navigate(`/game/${questionId}/${localeId}/welldone`)
    }
  }

  useEffect(() => {
    if (selectedLanguage) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      navigate(`/game/${questionId}/${selectedLanguage.id}`)
    }
  }, [selectedLanguage])

  useEffect(() => {
    if (localeId) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dispatch(
        fetchQuestionByLocaleRequest({
          questionId,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          localeId,
        }),
      )
    }
  }, [localeId])

  useEffect(() => {
    if (questionByLocale) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (questionByLocale.isPuzzleSolved) {
        socket.emit('check-if-team-is-removed', TeamId)
        navigate('/game')
      }
      dispatch(
        fetchWellDoneBackgroundRequest({
          questionId: questionByLocale?.questionId,
        }),
      )
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      activeAnswerType.current = questionByLocale?.answerType
      // setActiveAnswerType(questionByLocale?.answerType)
      const mappedChoices =
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        questionByLocale?.choices !== null
          ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            questionByLocale?.choices.map((choice: any, index: number) => {
              return {
                key: choice.key,
                value: choice.value,
                checked: false,
              }
            })
          : null
      setChoices(
        mappedChoices === null
          ? [
              { key: '1', checked: true, value: '' },
              { key: '2', checked: false, value: '' },
            ]
          : mappedChoices,
      )
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (questionByLocale?.answerType === 3) {
        const tempPadlockValue = []
        for (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          let index = 0, length = questionByLocale?.padlockLength || 3;
          index < length;
          index += 1
        ) {
          tempPadlockValue.push(0)
        }
        padlockAnswer.current = tempPadlockValue
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (questionByLocale?.answerType === 4) {
        const tempPadlockValue = []
        for (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          let index = 0, length = questionByLocale?.cryptexLength || 5;
          index < length;
          index += 1
        ) {
          tempPadlockValue.push('A')
        }
        padlockAnswer.current = tempPadlockValue
      }
    }
  }, [questionByLocale])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (puzzleAnswer?.isCorrect === false) {
      wrongAnswerSound()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (puzzleAnswer?.gotFiveWrongAnswers) {
        setShowWrongReminder(true)
      }
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (puzzleAnswer?.isCorrect) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (questionId == puzzleAnswer?.questionId) {
        correctAnswerSound()
        if (!displayWellDone) {
          displayWellDoneScreen()
        }
      }
    }
  }, [puzzleAnswer])

  const hintAgreeHandler = () => {
    // setHintAgree(true)
    clickSound()
    dispatch(
      postPuzzleHintRequest({
        questionId: questionByLocale?.questionId,
        supportedLocaleId: localeId,
        navigate,
      }),
    )
  }

  const nextHintHandler = (e: any) => {
    clickSound()
    confirmDialog({
      message: t('UseAnotherHintConfirm'),
      header: t('Confirmation'),
      icon: <Danger size="3rem" color="#333" variant="Bold" />,
      // icon: 'pi pi-exclamation-triangle',
      accept: () => {
        clickSound()
        dispatch(
          postPuzzleHintRequest({
            questionId: questionByLocale?.questionId,
            supportedLocaleId: localeId,
            navigate,
          }),
        )
      },
      acceptLabel: t('Yes'),
      rejectLabel: t('No'),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acceptClassName: generateCssClassYes(branding),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      rejectClassName: generateCssClassNo(branding),
      style: {
        width: '90%',
      },
      headerStyle: {
        background: branding?.modals.backgroundColor,
      },
      // reject,
    })
  }

  const onMultipleChange = (
    e: { value: any; checked: boolean },
    index: number,
  ) => {
    const _selectedChoices = [...choices]
    const findChoice = _selectedChoices.find((c) => c.key === e.value.key)
    if (findChoice) {
      findChoice.checked = e.checked
      _selectedChoices[index] = findChoice
    }
    setChoices(_selectedChoices)
  }

  const onRadioChange = (
    e: { value: any; checked: boolean },
    index: number,
  ) => {
    if (e.checked) {
      let _selectedChoices = [...choices]
      _selectedChoices = _selectedChoices.map((el) => ({
        ...el,
        checked: false,
      }))

      const findChoice = choices.find((c) => c.key === e.value.key)
      if (findChoice) {
        findChoice.checked = e.checked
        _selectedChoices[index] = findChoice
      }
      setChoices(_selectedChoices)
    }
  }

  const submitAnswer = () => {
    clickSound()
    confirmDialog({
      message: t('SubmitAnswerConfirm'),
      header: t('Confirmation'),
      icon: <Danger size="3rem" color="#333" variant="Bold" />,
      // icon: 'pi pi-exclamation-triangle',
      accept: handleSubmitAnswer,
      onHide: () => inputSound(),
      acceptLabel: t('Yes'),
      rejectLabel: t('No'),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acceptClassName: generateCssClassYes(branding),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      rejectClassName: generateCssClassNo(branding),
      style: {
        width: '90%',
      },
      headerStyle: {
        background: branding?.modals.backgroundColor,
      },
      // reject,
    })
  }

  const handleSubmitAnswer = () => {
    clickSound()

    // console.log('Submitted')
    const tempData: any = {
      questionId: questionByLocale?.questionId,
      supportedLocaleId: localeId,
      // supportedLocaleId: activeAnswerType === 3 ? null : localeId,
      answer:
        activeAnswerType.current === 1
          ? textAnswer
          : activeAnswerType.current === 3 || activeAnswerType.current === 4
          ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            padlockAnswer.current.join('')
          : null,
      answerType: activeAnswerType.current,
      choices:
        activeAnswerType.current === 2 || activeAnswerType.current === 5
          ? choices
              .filter((c: any) => c.checked === true)
              .map((c: any) => {
                return {
                  key: c.key,
                  value: c.value,
                }
                // return { key: c.key, value: c.value }
              })
          : null,
      puzzleSolvedTime: timer,
      userId: UserIdGame,
      questionIdGuid: questionId,
    }

    const apiUrl = `${ENDPOINT}/get-team-time`

    axios
      .get(apiUrl, {
        params: {
          teamId: TeamId,
        },
      })
      .then(function (response) {
        if (response.data) {
          tempData.puzzleSolvedTime = response.data
        }
        dispatch(postPuzzleAnswerRequest({ body: tempData, navigate }))
      })
      .catch(function (error) {
        Sentry.captureException(error)
        dispatch(postPuzzleAnswerRequest({ body: tempData, navigate }))
      })
  }

  const sanitizedData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ['iframe', 'video', 'source'],
      ADD_ATTR: [
        'src',
        'type',
        'controls',
        'style',
        'width',
        'height',
        'frameborder',
        'allowfullscreen',
        'class',
        'title',
        'referrerpolicy',
        'allow',
      ],
    }),
  })

  if (gameTimerDialog) {
    return (
      <Dialog
        header={t('GameTimeExpired')}
        visible={Boolean(gameTimerDialog)}
        style={{ width: '94vw', height: '30%' }}
        closable={false}
        onHide={() => null}
        headerStyle={{
          backgroundColor: branding?.modals.backgroundColor,
          color: branding?.modals.textColor,
        }}
      >
        <div className="flex flex-column text-center justify-content-center align-items-center">
          <p>{gameTimerDialog}</p>
        </div>
        <div style={{ width: '100%' }} className="flex justify-content-center">
          <Button
            label={t('FinishGame')}
            onClick={() => {
              clickSound()
              navigate('/end')
            }}
            type="button"
            // icon={<AlignBottom color="#fff" variant="Bold" className="mr-1" />}
            icon={
              <>
                <div
                  className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                  style={{
                    backgroundColor: branding?.buttonPrimary.textColor,
                  }}
                >
                  {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                </div>
                <ArrowRight
                  color={branding?.buttonPrimary.backgroundColor}
                  className="icon-center"

                  // className="p-button-icon p-c p-button-icon-right"
                />
              </>
            }
            className="p-button-rounded mt-5 p-button-raised w-full uppercase"
            style={{
              backgroundColor: branding?.buttonPrimary.backgroundColor,
              color: branding?.buttonPrimary.textColor,
            }}
            // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn"
          />
        </div>
      </Dialog>
    )
  }

  if (gameLoading.isLoadingQuestionByLocale) {
    return <Loading />
  }

  const accept = () => {
    clickSound()

    const apiUrl = `${ENDPOINT}/get-team-time`

    const tempData = {
      questionId: questionByLocale?.questionId,
      localeId,
      puzzleSolvedTime: timer,
      navigate,
      questionIdGuid: questionId,
    }

    axios
      .get(apiUrl, {
        params: {
          teamId: TeamId,
        },
      })
      .then(function (response) {
        if (response.data) {
          tempData.puzzleSolvedTime = response.data
        }
        dispatch(postSkipPuzzleRequest(tempData))
      })
      .catch(function (error) {
        Sentry.captureException(error)
        dispatch(postPuzzleAnswerRequest({ body: tempData, navigate }))
      })

    // setSkippedPuzzle(true)
  }

  const confirmSkipHandler = () => {
    clickSound()
    confirmDialog({
      message: t('SkipPuzzleConfirm'),
      header: t('Confirmation'),
      icon: <Danger size="3rem" color="#333" variant="Bold" />,
      // icon: 'pi pi-exclamation-triangle',
      accept,
      onHide: () => inputSound(),
      acceptLabel: t('Yes'),
      rejectLabel: t('No'),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acceptClassName: generateCssClassYes(branding),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      rejectClassName: generateCssClassNo(branding),
      style: {
        width: '90%',
      },
      headerStyle: {
        background: branding?.modals.backgroundColor,
      },
      // reject,
    })
  }

  return (
    <>
      <ConfirmDialog />
      <div
        className="flex flex-wrap justify-content-between"
        id="game-puzzle"
        style={{ width: '100%' }}
        // style={{ height: '100vh', width: '100%' }}
      >
        {gameTimerReminderDialog && (
          <Dialog
            header={t('GameTimeReminder')}
            visible={Boolean(gameTimerReminderDialog)}
            style={{ width: '94vw', height: '30%' }}
            onHide={() => setGameTimerReminderDialog(null)}
            headerStyle={{
              backgroundColor: branding?.modals.backgroundColor,
              color: branding?.modals.textColor,
            }}
          >
            <div className="flex flex-column text-center justify-content-center align-items-center">
              <p>
                <Trans
                  i18nKey="TimeWillExpireIn"
                  defaults="Your game time will expire in <bold>{{time}}</bold> minutes!"
                  /* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore */
                  values={{
                    time:
                      (gameTimerReminderDialog.timerTime -
                        gameTimerReminderDialog.timerEndReminderTime) /
                      60,
                  }}
                  components={{ bold: <strong /> }}
                />
              </p>
            </div>
          </Dialog>
        )}
        {showWrongReminder && (
          <Dialog
            header={t('Warning')}
            visible={Boolean(showWrongReminder)}
            style={{ width: '94vw', height: '30%' }}
            onHide={() => setShowWrongReminder(false)}
            closable
            headerStyle={{
              backgroundColor: branding?.modals.backgroundColor,
              color: branding?.modals.textColor,
            }}
          >
            <div className="flex flex-column text-center justify-content-center align-items-center">
              <p>{t('WrongAnswerWarningText')}</p>
            </div>
          </Dialog>
        )}
        <div className="p-3" style={{ height: '100%', width: '100%' }}>
          {/* <img
            src="/assets/layout/images/team-work.svg"
            // src="/assets/layout/images/logo.png"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{
              // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
              width: 'inherit',
            }}
          /> */}
          <div className="flex flex-column align-items-center">
            <h6 style={{ color: '#333' }}>{t('TimeBonus')}:</h6>
            {timer !== null ? (
              <Knob
                value={timer > 0 ? timer : 0}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                valueTemplate={
                  isUserUsingSeconds
                    ? timer > 0
                      ? timer.toString()
                      : '0'
                    : timer > 0
                    ? Math.ceil(timer / 60).toString()
                    : '0'
                }
                max={puzzleTimeValue.current}
                readOnly
                valueColor={branding?.buttonPrimary.backgroundColor}
              />
            ) : (
              <LoadingSpinner />
            )}
          </div>
          {/* <div className="flex justify-content-center my-3">
            <Language />
          </div> */}
          {/* <h2>Enter puzzle question!</h2> */}
          <div
            style={{ overflowWrap: 'break-word' }}
            className="img-full-width ql-editor my-3"
            dangerouslySetInnerHTML={sanitizedData(
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              decodeIframeString(questionByLocale?.questionHtml ?? '') ?? '',
            )}
          />
          {questionByLocale && activeAnswerType.current === 1 && (
            <div className="field">
              <label htmlFor="name" className="block">
                {t('EnterAnswer')}
              </label>
              <InputText
                value={textAnswer}
                onChange={(e) => {
                  setTextAnswer(e.target.value)
                  inputSound()
                }}
                id="answer"
                aria-describedby="answer-help"
                className={classNames('block sound-eff pl-4', {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  'correct-answer': puzzleAnswer?.isCorrect,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  'wrong-answer': puzzleAnswer?.isCorrect === false,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  'p-invalid': puzzleAnswer?.isCorrect === false,
                })}
                style={{ width: '100%' }}
              />
              {/* <small id="answer-help" className="block">
                Enter your game name.
              </small> */}
            </div>
          )}
          {questionByLocale &&
            (activeAnswerType.current === 2 ||
              activeAnswerType.current === 5) && (
              <div
                className={classNames('sound-eff w-full mb-3', {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  'correct-answer': puzzleAnswer?.isCorrect,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  'wrong-answer': puzzleAnswer?.isCorrect === false,
                })}
              >
                {choices.map((choice: any, index: number) => {
                  return (
                    <div
                      key={choice.key}
                      className={classNames('field-checkbox p-2 m-1 border-1', {
                        // 'border-1': choice.checked,
                        // 'px-1': choice.checked,
                        // 'py-2': choice.checked,
                        'border-round-sm': choice.checked,
                        'border-gray-500': choice.checked,
                        // 'border-primary': choice.checked,
                        'border-white': !choice.checked,
                      })}
                    >
                      {activeAnswerType.current === 2 ? (
                        <Checkbox
                          className="mr-3"
                          inputId={`choice${choice.key}`}
                          name={`choice${choice.key}`}
                          value={choice}
                          onChange={(e) => {
                            onMultipleChange(e, index)
                            inputSound()
                          }}
                          checked={choice.checked}
                        />
                      ) : (
                        <RadioButton
                          className="mr-3"
                          inputId={`choice${choice.key}`}
                          name={`choice${choice.key}`}
                          value={choice}
                          onChange={(e) => {
                            onRadioChange(e, index)
                            inputSound()
                          }}
                          checked={choice.checked}
                        />
                      )}
                      <label htmlFor={`choice${choice.key}`}>
                        {choice.value}
                      </label>
                    </div>
                  )
                })}
              </div>
            )}
          {questionByLocale && activeAnswerType.current === 3 && (
            <div className="flex justify-content-center">
              <div
                className={classNames('padlock', {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  'correct-answer': puzzleAnswer?.isCorrect,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  'wrong-answer': puzzleAnswer?.isCorrect === false,
                })}
              >
                {/* <div className="padlock"> */}
                <div className="padlock__sr">Unlock</div>
                <div className="padlock__top">
                  <div className="padlock__top-a"></div>
                  <div className="padlock__top-b"></div>
                </div>
                <div className="padlock__bottom">
                  <div className="lockInset">
                    <div className="lockLine"></div>
                    <div className="lockWrapper" ref={lockWrapper}>
                      <ScrollableWheel
                        sound={clickSound}
                        sensitivity={4}
                        columnsLength={questionByLocale?.padlockLength || 3}
                        items={Array.from(
                          { length: 10 },
                          (_, index) => index,
                        ).map((el) => ({ value: el, text: el }))}
                        onColumnChange={(value: any, index: any) => {
                          const currentAsnwer = [...padlockAnswer.current]
                          currentAsnwer[index] = value
                          padlockAnswer.current = currentAsnwer
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {questionByLocale && activeAnswerType.current === 4 && (
            <div
              className={classNames('sound-eff cryptexInset my-5', {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                'correct-answer': puzzleAnswer?.isCorrect,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                'wrong-answer': puzzleAnswer?.isCorrect === false,
              })}
            >
              <div className="cryptexLine"></div>
              <div className="cryptexWrapper" ref={lockWrapper}>
                <ScrollableWheel
                  sound={clickSound}
                  sensitivity={4}
                  columnsLength={questionByLocale.cryptexLength}
                  items={Array.from({ length: 26 }, (_, index) =>
                    String.fromCharCode(65 + index),
                  ).map((letter) => ({ value: letter, text: letter }))}
                  onColumnChange={(value: any, index: any) => {
                    const currentAsnwer = [...padlockAnswer.current]
                    currentAsnwer[index] = value
                    padlockAnswer.current = currentAsnwer
                  }}
                />
              </div>
            </div>
          )}
          <div className="flex flex-column justify-content-between align-items-center">
            <Button
              label={t('SubmitAnswer')}
              onClick={submitAnswer}
              loading={gameLoading.isCheckingPuzzleAnswer}
              type="button"
              icon={
                <>
                  <div
                    className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                    style={{
                      backgroundColor: branding?.buttonPrimary.textColor,
                    }}
                  >
                    {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                  </div>
                  <Send2
                    color={branding?.buttonPrimary.backgroundColor}
                    variant="Bold"
                    className="icon-center"

                    // className="p-button-icon p-c p-button-icon-right"
                  />
                </>
              }
              // icon={<Send2 color="#fff" variant="Bold" className="mr-1" />}
              className="p-button-rounded mb-2 py-3 zoominleft animation-duration-1000 uppercase w-full"
              style={{
                backgroundColor: branding?.buttonPrimary.backgroundColor,
                color: branding?.buttonPrimary.textColor,
              }}
              // className="p-button-rounded mb-2 p-button-raised w-full sign-in-btn zoominleft animation-duration-1000"
            />
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {questionByLocale?.questionHasHints && (
              <Button
                onClick={(e) => {
                  clickSound()
                  dispatch(
                    fetchUsedHintsRequest({
                      questionId: questionByLocale?.questionId,
                      localeId,
                    }),
                  )
                  setShowHintDialog(true)
                }}
                // icon={
                //   <GridEraser color="#DF6436" variant="Bold" className="mr-1" />
                // }
                icon={
                  <>
                    <div
                      className="p-2 p-button-icon p-button-icon-right rounded-icon-style-secondary"
                      style={{
                        backgroundColor: branding?.buttonSecondary.textColor,
                      }}
                    >
                      {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                    </div>
                    <GridEraser
                      color={branding?.buttonSecondary.backgroundColor}
                      variant="Bold"
                      className="icon-center"
                      // className="p-button-icon p-c p-button-icon-right"
                    />
                  </>
                }
                label={t('UseHint')}
                className="p-button-rounded p-button-outlined w-full mb-2 zoominright animation-duration-1000 uppercase"
                // className="p-button-rounded p-button-outlined w-full sign-in-btn mb-2 zoominright animation-duration-1000"
                aria-label="Text"
                aria-haspopup
                aria-controls="overlay_panel"
                style={{
                  backgroundColor: branding?.buttonSecondary.backgroundColor,
                  color: branding?.buttonSecondary.textColor,
                  border: `2px solid ${branding?.buttonSecondary.borderColor}`,
                }}
              />
            )}
            <Button
              label={t('SkipPuzzle')}
              onClick={confirmSkipHandler}
              // onClick={() => setVisible(true)}
              type="button"
              icon={
                <>
                  <div
                    className="p-2 p-button-icon p-button-icon-right rounded-icon-style-secondary"
                    style={{
                      backgroundColor: branding?.buttonSecondary.textColor,
                    }}
                  >
                    {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                  </div>
                  <BackSquare
                    color={branding?.buttonSecondary.backgroundColor}
                    variant="Bold"
                    className="icon-center"
                    // className="p-button-icon p-c p-button-icon-right"
                  />
                </>
              }
              // icon={
              //   <BackSquare color="#DF6436" variant="Bold" className="mr-1" />
              // }
              className="p-button-rounded p-button-outlined w-full zoominleft animation-duration-1000"
              // className="p-button-rounded p-button-outlined w-full sign-in-btn zoominleft animation-duration-1000"
              style={{
                backgroundColor: branding?.buttonSecondary.backgroundColor,
                color: branding?.buttonSecondary.textColor,
                border: `2px solid ${branding?.buttonSecondary.borderColor}`,
              }}
            />
          </div>
          <Dialog
            closable
            id="hint_dialog"
            style={{ width: '90%' }}
            onHide={() => {
              inputSound()
              setShowHintDialog(false)
            }}
            header={t('UseHint')}
            visible={showHintDialog}
            headerStyle={{
              backgroundColor: branding?.modals.backgroundColor,
              color: branding?.modals.textColor,
            }}
          >
            {gameLoading.isLoadingUsedHints ? (
              <LoadingSpinner />
            ) : (
              <>
                {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore */}
                {usedHints?.usedHints.length === 0 && (
                  <>
                    <h4 style={{ color: '#333' }}>{t('HintConfirm')}</h4>
                    <p>{t('ItWillAffectYourScore')}</p>
                    <p>
                      <Trans
                        i18nKey="WeWillTakeAwayPoints"
                        defaults="We will take away <bold>{{points}}</bold> points from you!"
                        /* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore */
                        values={{ points: usedHints?.hintToUsePoints }}
                        components={{ bold: <strong /> }}
                      />
                    </p>
                    <Button
                      label={t('Agree')}
                      onClick={hintAgreeHandler}
                      type="button"
                      // icon={
                      //   <Like1 color="#fff" variant="Bold" className="mr-1" />
                      // }
                      icon={
                        <>
                          <div
                            className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                            style={{
                              backgroundColor:
                                branding?.buttonPrimary.textColor,
                            }}
                          >
                            {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                          </div>
                          <Like1
                            color={branding?.buttonPrimary.backgroundColor}
                            variant="Bold"
                            className="icon-center"
                            // className="p-button-icon p-c p-button-icon-right"
                          />
                        </>
                      }
                      className="p-button-rounded mr-3 p-button-raised w-full"
                      style={{
                        backgroundColor:
                          branding?.buttonPrimary.backgroundColor,
                        color: branding?.buttonPrimary.textColor,
                      }}
                      // className="p-button-rounded mr-3 p-button-raised w-full sign-in-btn"
                    />
                  </>
                )}
                {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore */}
                {usedHints?.usedHints
                  .sort((a: any, b: any) => {
                    const keyA = parseInt(a.hintKey)
                    const keyB = parseInt(b.hintKey)

                    // Compare in descending order
                    if (keyA < keyB) {
                      return 1
                    }
                    if (keyA > keyB) {
                      return -1
                    }
                    return 0
                  })
                  .map((hint: any) => {
                    return (
                      <div
                        key={hint.hintKey}
                        style={{
                          overflowWrap: 'break-word',
                          borderBottom: '1px solid #ccc',
                          marginBottom: '1rem',
                        }}
                        dangerouslySetInnerHTML={sanitizedData(
                          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                          // @ts-ignore
                          decodeIframeString(hint.hintHtml + '</br>') ?? '',
                        )}
                        className="img-full-width ql-editor"
                      />
                    )
                  })}
                {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore */}
                {usedHints?.usedHints.length !== 0 &&
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  usedHints?.hasMoreHintsToUse && (
                    <>
                      <p style={{ marginTop: '0.5rem' }}>
                        {t('NextHintPoints')}:{' '}
                        {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore */}
                        <strong>{usedHints?.hintToUsePoints ?? null}</strong>
                      </p>

                      <Button
                        label={t('NextHint')}
                        onClick={nextHintHandler}
                        type="button"
                        // icon={
                        //   <Like1 color="#fff" variant="Bold" className="mr-1" />
                        // }
                        icon={
                          <>
                            <div
                              className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                              style={{
                                backgroundColor:
                                  branding?.buttonPrimary.textColor,
                              }}
                            >
                              {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                            </div>
                            <Like1
                              color={branding?.buttonPrimary.backgroundColor}
                              variant="Bold"
                              className="icon-center"
                              // className="p-button-icon p-c p-button-icon-right"
                            />
                          </>
                        }
                        className="p-button-rounded mr-3 p-button-raised w-full"
                        style={{
                          backgroundColor:
                            branding?.buttonPrimary.backgroundColor,
                          color: branding?.buttonPrimary.textColor,
                        }}
                        // className="p-button-rounded mr-3 p-button-raised w-full sign-in-btn"
                      />
                    </>
                  )}
              </>
            )}
          </Dialog>
        </div>
      </div>
    </>
  )
}

export default GamePuzzle
